import React, { useState, useEffect } from 'react';
import StorageService from 'services/StorageService';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR

const Tooltip = (props) => {
    const [show, setShow] = useState(false);
    const timer = props.timer;
    const once = props.once;
    
    useEffect(() => {
        if(once) {
            let reported = StorageService.getValidationStorage(props.type);

            if(!reported){
                setShow(true);

                setTimeout(() => {
                    setShow(false);
                    StorageService.updateValidationStorage(props.type);
                }, timer);
            }
        }
    }, []);
    
    const clickBtn = (event) => {
        setShow(false);
        event.preventDefault();
        StorageService.updateValidationStorage(props.type);
    }
    const mouseEnter = () => {
        if(!props.once){
            setShow(true)
        }
    }
    const mouseLeave = () => {
        if(!props.once){
            setShow(false)
        }
    }

    return(
        <div className={'tooltip-wrapper' + (!once ? ' hover' : '')}  onMouseEnter={mouseEnter}  onMouseLeave={mouseLeave}>
            {props.children}
            <div className={'tooltip-content' + ((once && show) ? ' visible' : '') }>
                <span className='tooltip-message' dangerouslySetInnerHTML={{ __html: props.message }}></span>
                {props.button && <button className="tooltip-button" onClick={clickBtn}>{props.button}</button>}
            </div>
        </div>
    )
}

Tooltip.propTypes = {
    timer: PropTypes.number,
    once: PropTypes.bool,
    children: PropTypes.node,
    type: PropTypes.string,
    message: PropTypes.string,
    button: PropTypes.string
}

export default Tooltip;